import React from 'react';
import { useTimer } from 'react-timer-hook';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Units from './Units';

export default function MyTimer({ expiryTimestamp, css }) {
    const {
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        resume,
        restart,
    } = useTimer({ expiryTimestamp, onExpire: () => console.warn('onExpire called') });


    return (
        <div style={{ textAlign: 'center' }}>
            {/* <h1>react-timer-hook </h1>
            <p>Timer Demo</p> */}
            <div style={{
                fontSize: css?.fontSize ? css?.fontSize : "1.2rem",
                color: css?.color ? css?.color : "black",
                gap: '0.5rem',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <AccessTimeIcon style={{ fontSize: css?.fontSize ? css?.fontSize : "1.2rem", color: css?.color ? css?.color : "black" }} />
                {/* <span>{days}</span>:<span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span> */}
                <div>
                    {/* <span>{hours}</span>:<span>{minutes}</span>:<span>{seconds}</span> */}
                    <span>{minutes}</span>:<span>{seconds < 10 ? '0' + seconds.toString() : seconds}</span>
                </div>
            </div>
            {/* <p>{isRunning ? 'Running' : 'Not running'}</p>
            <button onClick={start}>Start</button>
            <button onClick={pause}>Pause</button>
            <button onClick={resume}>Resume</button>
            <button onClick={() => {
                // Restarts to 5 minutes timer
                const time = new Date();
                time.setSeconds(time.getSeconds() + 300);
                restart(time)
            }}>Restart</button> */}
        </div>
    );
}